import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import useTheme from '../../hooks/useTheme'

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      type='button'
      onClick={toggleTheme}
      title={isDark ? 'Modo claro' : 'Modo oscuro'}
      aria-label={isDark ? 'Activar modo claro' : 'Activar modo oscuro'}
      className={`w-10 h-10 flex items-center justify-center rounded-xl text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-dk-hover dark:hover:text-white transition-all duration-300 ${className}`}
    >
      <FontAwesomeIcon icon={isDark ? faSun : faMoon} className='text-base' />
    </button>
  )
}

export default ThemeToggle
